var map = {
	"./clo-icon.png": 5866,
	"./ese-icon.png": 9404,
	"./furture-icon.png": 7981,
	"./high-icon.png": 9947,
	"./lewis-icon-1.png": 9517,
	"./lewis-icon-2.png": 104,
	"./nat-icon.png": 5147,
	"./pai-icon.png": 9584,
	"./paitiff-icon.png": 9115,
	"./sandey-icon.png": 1626
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2901;